import { SET_DICT_BY_NAME } from '../actions/dictionaries.actions';

const initialState = {
  userTemplates: [],
  userClasses: {},
  reportName: [],
  reportNames: [],
  reportCategories: [],
  transformationTypes: [],
  reportExtensions: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DICT_BY_NAME: {
      return { ...state, [action.payload.name]: action.payload.items };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries.reducer.js